(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ft-promo"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-ft-promo-rotate]').forEach(function (wrap) {
    if (wrap.dataset.ftRotating) return;
    var slides = Array.prototype.slice.call(wrap.querySelectorAll('.ft-promo__img--slide'));
    if (!slides.length) return;
    wrap.dataset.ftRotating = '1';

    var promo = wrap.closest('.ft-promo');
    var btn = wrap.querySelector('[data-ft-promo-toggle]');
    var label = wrap.querySelector('[data-ft-promo-label]');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var i = 0;

    /* Rolling window: only the slide on screen and its immediate neighbours ever
       get a src. Everything else stays inert markup until it is nearly needed. */
    function arm(n) {
      var s = slides[((n % slides.length) + slides.length) % slides.length];
      if (!s || s.getAttribute('src')) return;
      if (s.dataset.srcset) s.setAttribute('srcset', s.dataset.srcset);
      if (s.dataset.src) s.setAttribute('src', s.dataset.src);
    }

    slides[0].classList.add('is-on');
    arm(0); arm(1); arm(-1);

    if (slides.length < 2 || reduced) {
      if (btn) btn.remove();
      return;
    }

    var timer = null;
    var manualPaused = false;
    var inView = true;

    function tick() {
      slides[i].classList.remove('is-on');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-on');
      arm(i + 1); // fetch the one after next while this crossfade plays
    }
    function sync() {
      var shouldRun = !manualPaused && inView && !document.hidden;
      if (shouldRun && !timer) timer = setInterval(tick, 3500);
      if (!shouldRun && timer) { clearInterval(timer); timer = null; }
    }

    if (btn) {
      btn.addEventListener('click', function () {
        manualPaused = !manualPaused;
        if (promo) promo.classList.toggle('is-rotator-paused', manualPaused);
        btn.setAttribute('aria-pressed', manualPaused ? 'true' : 'false');
        if (label) label.textContent = manualPaused ? 'Resume the rotating product images' : 'Pause the rotating product images';
        sync();
      });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { inView = e.isIntersecting; });
        sync();
      }, { threshold: 0.1 }).observe(wrap);
    }
    document.addEventListener('visibilitychange', sync);
    sync();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ft-ticker"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-ft-ticker-toggle]').forEach(function (btn) {
    if (btn.dataset.ftWired) return;
    btn.dataset.ftWired = '1';
    var strip = btn.closest('.ft-ticker');
    var label = btn.querySelector('[data-ft-ticker-label]');
    if (!strip) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      strip.classList.add('is-paused');
      btn.setAttribute('aria-pressed', 'true');
      if (label) label.textContent = 'Resume scrolling announcements';
    }

    btn.addEventListener('click', function () {
      var paused = strip.classList.toggle('is-paused');
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      if (label) label.textContent = paused ? 'Resume scrolling announcements' : 'Pause scrolling announcements';
    });
  });

  if ('IntersectionObserver' in window) {
    document.querySelectorAll('[data-ft-ticker]').forEach(function (strip) {
      if (strip.dataset.ftSeen) return;
      strip.dataset.ftSeen = '1';
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          strip.classList.toggle('is-offscreen', !e.isIntersecting);
        });
      }, { threshold: 0 });
      io.observe(strip);
    });
  }

  document.addEventListener('visibilitychange', function () {
    document.querySelectorAll('[data-ft-ticker]').forEach(function (strip) {
      strip.classList.toggle('is-offscreen', document.hidden);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
